import React, { useState } from 'react';
import ColumnFilter from '../ColumnFilter';
import { useDebouncedOnChange } from '@/hooks';
import { useAreas } from '@/core/domain/operational/Areas/Areas.hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { Button, Divider } from 'antd';

interface Props {
  onChange(value: number): void;
  value?: number;
}

const SubAreasColumnFilter: React.FC<Props> = (props) => {
  const [search, setSearch] = useState('');
  const [value, setValue] = useState();

  const onSearch = useDebouncedOnChange(setSearch);

  const {
    data: areasData,
    isLoading,
    isFetching,
    hasNextPage,
    fetchNextPage,
  } = useAreas({ name: search, active: true });

  const areas = flatInfiniteData(areasData);

  return (
    <ColumnFilter
      loading={isLoading}
      onSearch={onSearch}
      onChange={(value) => {
        props.onChange(value);
        setValue(value);
      }}
      value={props.value || value}
      dropdownComponent={(Component) =>
        areas?.map((area, index) =>
          area.subAreas?.length ? (
            <div key={area.id}>
              {index > 0 && <Divider style={{ margin: 0, marginBottom: 7 }} />}
              <div
                style={{
                  color: 'darkgrey',
                  fontSize: 10,
                  marginLeft: 4,
                  fontWeight: 600,
                }}
              >
                {area.name}
              </div>

              {area.subAreas.map((subArea) => (
                <Component
                  key={subArea.id}
                  item={{ value: subArea.id, label: subArea.name }}
                />
              ))}
            </div>
          ) : null,
        )
      }
      footer={
        hasNextPage && (
          <Button
            type="primary"
            block
            loading={isFetching}
            onClick={() => fetchNextPage()}
          >
            Carregar mais
          </Button>
        )
      }
    />
  );
};

export default SubAreasColumnFilter;
